export default "__VITE_ASSET__26851b2b__"